// Although this file contains nothing, we need at least one file for webpack to
// generate a valid head.js. AEM already points to head.js, so it is better to
// provide an empty file than force them to patch it out. We will more than
// likely need a head.js in the future.
export {};
